import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';

interface PrimaryButtonProps extends ButtonProps {
  buttonColor?: "primary-green" | "white" | "secondary" | "secondary-white" | "yellow" | "red"
}

//#facc15
function PrimaryButton({ buttonColor = "primary-green", ...props }: PrimaryButtonProps) {

  const CustomButton = styled(Button)({
    textTransform: 'none',
    backgroundColor: buttonColor == "primary-green" ? "#009C4E" : buttonColor == "white" ? "#FFFFFF" : buttonColor == "yellow" ? "#facc15" : (buttonColor == "red" ? "#ef4444" : "transparent"),
    color: buttonColor == "primary-green" || buttonColor == "secondary-white" || buttonColor == "red" ? "#FFFFFF" : buttonColor == "yellow" ? "#000000" : "#009C4E",
    width: "100%",
    border: buttonColor == "secondary" || buttonColor == "secondary-white" ? "1px solid" : "",
    borderColor: buttonColor == "secondary" ? "#009C4E" : buttonColor == "secondary-white" ? "#FFFFFF" : ""
  })

  return (
    <CustomButton
      {...props}
    >

    </CustomButton>
  );
}

export default PrimaryButton;